module.exports = __webpack_public_path__ + "img/ceremonial_totem_small.a60cb672.png";